// Mock data for Santorini vacation rentals

export const properties = [
  {
    id: 1,
    name: "The Feelings",
    nameEn: "The Feelings",
    description: "Μεζονέτα 75 τ.μ. με θέα στη θάλασσα, το βουνό και την ανατολή του ηλίου",
    descriptionEn: "75 sq.m. maisonette with sea, mountain and sunrise view",
    image: "https://a0.muscache.com/im/pictures/8b2c981c-af77-4d03-8239-f67198c0fdfb.jpg?im_w=720",
    price: 120,
    maxGuests: 5,
    bedrooms: 2,
    bathrooms: 1,
    amenities: ["WiFi", "A/C", "TV", "Θέα", "Parking"],
    available: true,
    gallery: [
      "https://a0.muscache.com/im/pictures/8b2c981c-af77-4d03-8239-f67198c0fdfb.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/c52abe46-098d-4cdf-b6d2-027dcc3b5606.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/318808c7-311b-4e79-b9c6-2b1e7f48bb9f.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/90fd3c31-23a0-465a-99d1-215d38445776.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/f1226b82-fe08-432d-9228-86d812dcfba3.jpg?im_w=720"
    ]
  },
  {
    id: 2,
    name: "Courtly Love",
    nameEn: "Courtly Love",
    description: "Μεζονέτα 60 τ.μ. με πανοραμική θέα στη θάλασσα και τη Νάφι",
    descriptionEn: "60 sq.m. maisonette with panoramic sea view and Anafi island",
    image: "https://a0.muscache.com/im/pictures/f7753e8d-bd2d-462b-a6ea-b92b7c1c8115.jpg?im_w=720",
    price: 100,
    maxGuests: 4,
    bedrooms: 1,
    bathrooms: 1,
    amenities: ["WiFi", "A/C", "TV", "Θέα", "Parking"],
    available: true,
    gallery: [
      "https://a0.muscache.com/im/pictures/f7753e8d-bd2d-462b-a6ea-b92b7c1c8115.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/43b8f9a0-3f8e-41f0-a2d5-b84aa5866276.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/fda7e404-cc57-4f09-bf2a-2affd7877df8.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/d3e3bbe8-64ef-4efa-a78e-625ed5a947aa.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/98b5a49f-b9fd-4c56-9fee-eb3e17aa44e9.jpg?im_w=720"
    ]
  },
  {
    id: 3,
    name: "Feelings #3",
    nameEn: "Feelings #3",
    description: "Άνετο σπίτι στο Εμπορείο, 5 λεπτά από την παραλία",
    descriptionEn: "Cozy house in Emporio, 5 minutes from the beach",
    image: "https://a0.muscache.com/im/pictures/14da4cb0-1416-4c3d-9310-ea07377d44e5.jpg?im_w=720",
    price: 110,
    maxGuests: 4,
    bedrooms: 2,
    bathrooms: 1,
    amenities: ["WiFi", "A/C", "TV", "Θέα", "Parking"],
    available: true,
    gallery: [
      "https://a0.muscache.com/im/pictures/14da4cb0-1416-4c3d-9310-ea07377d44e5.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/90fd3c31-23a0-465a-99d1-215d38445776.jpg?im_w=720"
    ]
  },
  {
    id: 4,
    name: "Feelings #4",
    nameEn: "Feelings #4",
    description: "Παραδοσιακό σπίτι με αυλή και θέα στο βουνό",
    descriptionEn: "Traditional house with courtyard and mountain view",
    image: "https://a0.muscache.com/im/pictures/318808c7-311b-4e79-b9c6-2b1e7f48bb9f.jpg?im_w=720",
    price: 95,
    maxGuests: 4,
    bedrooms: 2,
    bathrooms: 1,
    amenities: ["WiFi", "A/C", "TV", "Θέα", "Parking"],
    available: true,
    gallery: [
      "https://a0.muscache.com/im/pictures/318808c7-311b-4e79-b9c6-2b1e7f48bb9f.jpg?im_w=720",
      "https://a0.muscache.com/im/pictures/c52abe46-098d-4cdf-b6d2-027dcc3b5606.jpg?im_w=720"
    ]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://a0.muscache.com/im/pictures/8b2c981c-af77-4d03-8239-f67198c0fdfb.jpg?im_w=720",
    title: "The Feelings - Υπνοδωμάτιο"
  },
  {
    id: 2,
    url: "https://a0.muscache.com/im/pictures/c52abe46-098d-4cdf-b6d2-027dcc3b5606.jpg?im_w=720",
    title: "Θέα από το μπαλκόνι"
  },
  {
    id: 3,
    url: "https://a0.muscache.com/im/pictures/318808c7-311b-4e79-b9c6-2b1e7f48bb9f.jpg?im_w=720",
    title: "Εξωτερικός χώρος"
  },
  {
    id: 4,
    url: "https://a0.muscache.com/im/pictures/90fd3c31-23a0-465a-99d1-215d38445776.jpg?im_w=720",
    title: "Καθιστικό"
  },
  {
    id: 5,
    url: "https://a0.muscache.com/im/pictures/f7753e8d-bd2d-462b-a6ea-b92b7c1c8115.jpg?im_w=720",
    title: "Courtly Love"
  },
  {
    id: 6,
    url: "https://a0.muscache.com/im/pictures/43b8f9a0-3f8e-41f0-a2d5-b84aa5866276.jpg?im_w=720",
    title: "Εσωτερικός χώρος"
  },
  {
    id: 7,
    url: "https://a0.muscache.com/im/pictures/fda7e404-cc57-4f09-bf2a-2affd7877df8.jpg?im_w=720",
    title: "Κουζίνα"
  },
  {
    id: 8,
    url: "https://a0.muscache.com/im/pictures/d3e3bbe8-64ef-4efa-a78e-625ed5a947aa.jpg?im_w=720",
    title: "Μπάνιο"
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1580502304784-8985b7eb7260?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxTYW50b3Jpbml8ZW58MHx8fHwxNzc1Njc3ODgyfDA&ixlib=rb-4.1.0&q=85",
    title: "Σαντορίνη Ηλιοβασίλεμα"
  },
  {
    id: 10,
    url: "https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxTYW50b3Jpbml8ZW58MHx8fHwxNzc1Njc3ODgyfDA&ixlib=rb-4.1.0&q=85",
    title: "Μπλε Τρούλος"
  }
];

export const amenitiesList = [
  { icon: "Wifi", name: "WiFi", description: "Δωρεάν υψηλής ταχύτητας" },
  { icon: "AirVent", name: "A/C", description: "Σε όλους τους χώρους" },
  { icon: "Tv", name: "TV", description: "Smart TV με streaming" },
  { icon: "Eye", name: "Θέα", description: "Απεριόριστη θέα Καλντέρας" },
  { icon: "Car", name: "Parking", description: "Δωρεάν χώρος στάθμευσης" }
];

// Mock bookings - stored in localStorage
export const mockBookings = [];

export const addBooking = (booking) => {
  const bookings = JSON.parse(localStorage.getItem('bookings') || '[]');
  const newBooking = {
    ...booking,
    id: Date.now(),
    status: 'pending',
    createdAt: new Date().toISOString()
  };
  bookings.push(newBooking);
  localStorage.setItem('bookings', JSON.stringify(bookings));
  return newBooking;
};

export const getBookings = () => {
  return JSON.parse(localStorage.getItem('bookings') || '[]');
};

export const checkAvailability = (propertyId, checkIn, checkOut) => {
  const bookings = getBookings();
  const propertyBookings = bookings.filter(b => 
    b.propertyId === propertyId && 
    b.status === 'confirmed'
  );
  
  for (let booking of propertyBookings) {
    const bookingStart = new Date(booking.checkIn);
    const bookingEnd = new Date(booking.checkOut);
    const requestStart = new Date(checkIn);
    const requestEnd = new Date(checkOut);
    
    if (
      (requestStart >= bookingStart && requestStart < bookingEnd) ||
      (requestEnd > bookingStart && requestEnd <= bookingEnd) ||
      (requestStart <= bookingStart && requestEnd >= bookingEnd)
    ) {
      return false;
    }
  }
  
  return true;
};
